
import dataJson from "@/../public/data.json";

import "./index.less";
const prefix = "designStory";

function DesignStory() {
  const { design_story } = dataJson;
  return (
    <div className={prefix}>
      <div className={`${prefix}-title`} style={{backgroundImage:`url(${design_story.design_story_bg})`}}>
        <div className={`${prefix}-title-text`}>开启本真智联世界</div>
      </div>
      <div className={`${prefix}-content`} style={{backgroundImage:`url(${design_story.design_story_content})`}}></div>
      <div className={`${prefix}-expectation`} style={{backgroundImage:`url(${design_story.light_ball})`}}>
        <div className={`${prefix}-expectation-exciting`}>精彩设计</div>
        <div className={`${prefix}-expectation-place`}>敬请期待</div>
        <div className={`${prefix}-expectation-characteristic`}>
          <div>
            <span></span>自然色彩
          </div>
          <div>
            <span></span>极简形态
          </div>
          <div>
            <span></span>纯真质感
          </div>
          <div>
            <span></span>本能交互
          </div>
          <div>
            <span></span>原力动效
          </div>
          <div>
            <span></span>仿真空间
          </div>
        </div>
        <div className={`${prefix}-expectation-more`}>......</div>
      </div>
      <div className={`${prefix}-kaihong`} style={{backgroundImage:`url(${design_story.kaihong_design})`}}></div>
    </div>
  );
}

export default DesignStory;
